<template>
  <div class="slice">
    <div class="vid-wrapper">
      
      <video ref="vid" @loadeddata="onLoaded" loop :width="vidSize" :height="vidSize">
        <source :src="url"/>
      </video>
    </div>
  </div>
</template>

<script>
export default {
  props: ['currentTime','fileName','vidSize'],
  mounted(){
    // var sgif = new SuperGif({ gif: this.$refs.image, max_width: 180} );
    // this.sgif = sgif
    // sgif.load_url(this.url,()=>{
    //   sgif.move_to(this.currentTime)
    // })
    // this.offCanvas = new OffscreenCanvas(640,480)
    // this.createSgif().then(this.drawCurrentFrame)
    // this.sync()
   
  },
  methods: {
    // createSgif(){
    //   let parent = document.createElement('div')
    //   let el = new Image()
    //   parent.appendChild(el)
    //   let sgif = new SuperGif({ gif: el} );
    //   return new Promise((resolve)=>{
    //     // let url = `https://projects.bestiario.org/elem/data/videos/${fileName}.gif`
    //     sgif.load_url(this.url,()=>{
    //       this.frames = sgif.get_frames()
    //       resolve()
    //     })
    //   })
    // },
    // drawCurrentFrame () {
    //   // this.sgif.get_frames()[this.frameIndex]
    //   let imdata = this.frames[this.currentTime].data
    //   let ctx = this.$refs.canvas.getContext('2d')
    //   let offCtx = this.offCanvas.getContext('2d')
    //   offCtx.putImageData(imdata,0,0)
    //   ctx.setTransform(0.2,0,0,0.2,0,0);
    //   ctx.drawImage(this.offCanvas, 0, 0);
    // }
    onLoaded(){
      this.$emit('loaded',this.$refs.vid.duration)
    },
    sync (time){
      if(this.$refs.vid){
        this.$refs.vid.currentTime = time
      }
      // requestAnimationFrame(this.sync)
    },
    playVid(){
      this.$refs.vid.play()
    },
    pauseVid(){
      this.$refs.vid.pause()
    }
  },
  computed:{
    url(){
      // return `static_data/case/videos/${this.fileName}.gif`
      // console.log("mp4",this.fileName)
      return this.fileName //`static_data/case/videos/NEW_VIDEOS/run_name-LAX1.mp4` //p.gif
    },
    // vidSize(){
    //   //TODO HACERLO "dynamico" cuando resizes el pader
    //   return 140 //this.$parent.$el.closest('.slices-container').getBoundingClientRect().width/4
    // }
  },
  watch:{
    // currentTime (val) {
    //   // this.sgif.move_to(val)
    //   this.drawCurrentFrame()
    // },
    // fileName(val){
    //   this.sgif.load_url(this.url,()=>{
    //     this.sgif.move_to(this.currentTime)
    //   })
    // },
    // url(val){
    //   this.createSgif().then(this.drawCurrentFrame)
    // }
  }
}
</script>

<style lang="stylus" scoped>
.slice
  flex-direction column
  .vid-wrapper
    height auto
    overflow hidden
    // video 
    //   width: 120px
    //   height 120px
</style>